import React from 'react';
import { Header } from '../components/Header';

export default class Agreement extends React.Component {
    render() {
        return (
            <>
                <Header simple={true} />
                <p className="o-form-wrapper__text">
                    Пользовательское Соглашение
                    <br />
                    Настоящее Пользовательское Соглашение (Далее Соглашение) регулирует отношения между владельцем learnew.ru (далее Рабочая тетрадь по иностранному языку или Администрация) с одной стороны и пользователем сайта с другой.
                    Сайт Рабочая тетрадь по иностранному языку не является средством массовой информации.

                    Используя сайт, Вы соглашаетесь с условиями данного соглашения.
                    Если Вы не согласны с условиями данного соглашения, не используйте сайт Рабочая тетрадь по иностранному языку!

                    Предмет соглашения
                    <br />
                    <br />
                    - Текстовой информации
                    - Ссылок на материалы, размещенные на других сайтах

                    Права и обязанности сторон
                    <br />
                    <br />
                    Пользователь имеет право:
                    - осуществлять поиск информации на сайте
                    - получать информацию на сайте
                    - создавать информацию для сайта
                    - распространять информацию на сайте
                    - копировать информацию на другие сайты с указанием источника
                    - копировать информацию на другие сайты с разрешения правообладателя
                    - использовать информацию сайта в личных некоммерческих целях

                    Администрация имеет право:
                    <br />
                    <br />
                    - по своему усмотрению и необходимости создавать, изменять, отменять правила
                    - ограничивать доступ к любой информации на сайте
                    - создавать, изменять, удалять информацию
                    - удалять учетные записи

                    Пользователь обязуется:
                    <br />
                    <br />
                    - обеспечить достоверность предоставляемой информации
                    - обеспечивать сохранность личных данных от доступа третьих лиц
                    - не распространять информацию, которая направлена на пропаганду войны, разжигание национальной, расовой или религиозной ненависти и вражды, а также иной информации, за распространение которой предусмотрена уголовная или административная ответственность
                    - не нарушать работоспособность сайта
                    - не передавать в пользование свою учетную запись и/или логин и пароль своей учетной записи третьим лицам
                    - не регистрировать учетную запись от имени или вместо другого лица за исключением случаев, предусмотренных законодательством РФ
                    - не размещать материалы рекламного, эротического, порнографического или оскорбительного характера, а также иную информацию, размещение которой запрещено или противоречит нормам действующего законодательства РФ
                    - не использовать скрипты (программы) для автоматизированного сбора информации и/или взаимодействия с Сайтом и его Сервисами

                    Администрация обязуется:
                    <br />
                    <br />
                    - поддерживать работоспособность сайта за исключением случаев, когда это невозможно по независящим от Администрации причинам.
                    - осуществлять разностороннюю защиту учетной записи Пользователя

                    Ответственность сторон
                    <br />
                    <br />
                    - пользователь лично несет полную ответственность за распространяемую им информацию
                    - администрация не несет никакой ответственности за достоверность информации, скопированной из других источников
                    - администрация не несёт ответственность за несовпадение ожидаемых Пользователем и реально полученных услуг
                    - администрация не несет никакой ответственности за услуги, предоставляемые третьими лицами
                    - в случае возникновения форс-мажорной ситуации (боевые действия, чрезвычайное положение, стихийное бедствие и т. д.) Администрация не гарантирует сохранность информации, размещённой Пользователем, а также бесперебойную работу информационного ресурса

                    Условия действия Соглашения
                    <br />
                    <br />
                    Данное Соглашение вступает в силу при любом использовании данного сайта.
                    Соглашение перестает действовать при появлении его новой версии.
                    Администрация оставляет за собой право в одностороннем порядке изменять данное соглашение по своему усмотрению.
                    Администрация не оповещает пользователей об изменении в Соглашении.

                    <br />
                    <br />
                    Соглашение разработано на базе юридических документов сервиса <a href='https://praville.ru/generator/a_gen.php#'>Правилль</a>
                </p>
            </>
        )

    }
}